
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//土耳其
export const lang ={
  Please_set_materialtype_in_product_page:"Her bir ürünün - bitmiş ürünler - yarı mamuller - aksesuarların malzeme türünü değiştirmek ve ayarlamak için lütfen ürün sayfasına gidin.",
deleteAccount:"Çıkış Yap",
deleteAccountWillDeleteAllData:"Hesabınızdan çıkış yapmak tüm verileri silecek ve giriş yapamamanıza neden olacaktır.",
backupDatabase:"Yedek veritabanı",
restoreDatabase:"Veritabanını geri yükle",
materialtype:"Malzeme Türü",
Manufacturing:"Üretim versiyonu",
Professional:"Profesyonel sürüm",
Standard:"Standart Sürüm",
product:"Tamamlanmış ürün",
halfProduct:"Yarı mamul ürünler",
components:"Aksesuarlar",
Parent:"ana bileşen",
Children:"Alt aksesuarlar",
Level:"Hiyerarşi",
Timing:"Zamanlama",
PieceCount:"Parça işi",
Wages:"Ücretler",
InternalProcess:"İç süreç",
ExternalProcess:"harici süreç",
ProceName:"İşlem adı",
ProceIndex:"İnfaz emri",
ChargeMan:"müdür",
BillMethod:"Faturalandırma yöntemi",
ConsumTime:"çalışma saatleri",
Accessories:"Aksesuarlar",
Assembly:"Birleştirmek",
materials:"malzemeler",
task:"Görev",
process:"işlem",
BOM:"ürün reçetesi",
Production:"Üretme",
RestorePurchaseOneUse:"Satın alma işlemini geri yükleme (tek kullanıcı (önceki satın alma işlemleriyle sınırlıdır))",
buy_fail_try_again:"Satın almak için lütfen tekrar tıklayın",
Export:"İhracat",
Date:"tarih",
BankDetail:"banka detayları",
Seller:"satıcı",
Buver:"alıcı",
Currency:"para birimi",
CompanyName:"Firma Adı",
ProformaInvoice:"proforma fatura",
Discount:"İndirim",
PayStatus:"Ödeme durumu",
ShippingStatus:"Nakliye durumu",
FreightType:"Ulaşım türü",
Shipping:"navlun",
Payment:"Ödeme",
Moneyname:"para birimi adı",
Tax:"vergiler",
Freight:"Navlun ücretleri",
Insurance:"sigorta",
Bankfee:"banka ücretleri",
Qc:"Kalite Belgelendirmesi",
Exchangerate:"Döviz kuru",
Shippingnumber:"gönderi numarası",
ShipDate:"Gönderim tarihi",
Arrivedate:"varış tarihi",
Grossweight:"Brüt ağırlık",
CubicWeight:"kübik ağırlık",
Totalpackages:"Toplam paket sayısı",
Moneytype:"para birimi türü",
Quotedate:"teklif tarihi",
Validitydate:"Geçerli tarih",
Paymentterm:"maaşın sona ermesi",
Priceterm:"fiyatlandırma terimi",
DeliveryTerm:"Teslimat süresi",
BankName:"banka adı",
BankAddress:"banka adresi",
SwiftCode:"Banka kodu",
Review:"Gözden geçirmek",
Signfor:"Makbuz için imzalayın",
Finance:"finans",
Receiver:"Alıcı",
Business:"işletme",
ContactPerson:"İlgili kişi",
Profit:"kâr",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Çalışanlar Google Chrome kullanmalıdır. Lütfen ana hizmet bilgisayarı uygulamasının yardım sayfasındaki IP adresini kontrol edin ve ardından girişi açmak için diğer bilgisayar tarayıcılarının URL sütununa adresi girin.",
newPassword:"Yeni Şifre",
ForgetPassword:"şifreyi unut",
ContactUs:"Bize ulaşın/öneride bulunun",
Actualpay_should_big_then_shouldpay:"Fiili tahsilatlar alacaklardan fazla olamaz",
ShopAddress:"Mağaza adresim Sipariş vermek için QR kodunu tarayın",
Submit:"göndermek",
All:"Tümü",
OrdernumExists:"Sipariş numarası zaten mevcut",
PermissionDenied:"izin reddedildi",
StockTransfer:"Stok transferi",
FromWarehouse:"Depodan dışarı aktarma",
ToWarehouse:"Depoya transfer",
PleaseUseInWebBrowser:"Lütfen Google Chrome'daki Excel'i dışa aktarma işlevini kullanın",
PleasePrintInWebBrowser:"Lütfen Google Chrome'daki yazdırma işlevini kullanın",
HistoryPrice:"tarihsel fiyat",
SerialNumber:"seri numarası",
Please_Use_In_APP:"Lütfen bilgisayar yazılımı içinde kullanın",
Please_Purchase_In_APP:"Lütfen tarayıcıdan değil, uygulamadan satın alın",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Postgresql veritabanına bağlanabilirsiniz. Verileriniz Postgresql veritabanında saklanacaktır. Varsayılan olarak Postgresql veritabanına bağlanmanıza gerek yoktur. Varsayılan yerel Sqlite veritabanıdır.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Postgresql veritabanına bağlanın, verileriniz Postgresql veritabanında saklanacak ve veriler tekrar okunacaktır.",
Use_sqlite_data_will_store_in_local:"Sqlite kullanılarak veriler yerel makinede saklanacaktır.",
UsePostgresqlDatabase:"PGSQL veritabanını kullanma",
UseSqliteDatabase:"Sqlite veritabanını kullanma",
DatabaseName:"Ad veritabanı",
Test_connect:"test bağlantısı",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Ürünün rengi ve bedeni varsa ilk stok için lütfen 0 giriniz.Ürünü ekledikten sonra satın alma işleminde envantere giriniz.",
my:"bana ait",
my_shop_qrcode_scan:"Mağazamın QR kodu, müşterilere sipariş vermek için kodu tarayabilme olanağı sağlar. Müşterinin cep telefonu, bilgisayarınızla aynı yönlendiriciye bağlı olmalıdır.",
ip:"IP",
port:"Liman",
orderstatus:"Sipariş durumu",
image:"resim",
Template:"şablon",
Please_select_a_excel_file:"Lütfen bir dosya seçin",
Please_select_only_one_excel_file:"Yalnızca bir dosya seçilebilir",
Connect_Internet_Login_again:"Satın almadan önce İnternet'e bağlanın ve tekrar oturum açın",

    productHasValidDate:'Ürünün geçerli bir süresi var',
productHasColor:'Ürünün renk boyutu var',
GeneralGoods:'Genel mallar',
Selected:'seçilmiş',
RestorePurchase:'Satın almaya devam et',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Sürekli olarak Faturalama Enterprise Edition 1 kullanıcıları satın alın',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Faturalama Enterprise Edition’ı satın alın kullanıcılar ve cihazlar için sınırsızdır',
Purchasing:'Alış ... Lütfen sabırla bekleyin ...',
Validdate:'Geçerlilik süresi',
Makedate:'Üretim tarihi',
Batch:'yığın',
CheckVersion:'Versiyonu kontrol et',
Please_set_this_ip_address_on_App:'Lütfen bu IP adresini veya bilgisayarın IP adresini APP’de ayarlayın.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Bu bağlantıyı bilgisayarınızda veya mobil tarayıcınızda açın (aynı WiFi bağlantısını kurun)',


    CheckVersion:'Versiyonu kontrol et',
You_need_to_purchase:'Henüz satın almadınız, lütfen WeChat‘i Elink9988 E-posta’ya ekleyin:bvbuy@qq.com',
Thank_for_your_purchase:'Zaten satın aldın',
New_version_available:'Yeni sürüm var',
Is_the_latest_version:'en son sürüm',
    please:'Lütfen',
input:'giriş',
wrong:'yanlış',
Verifycode:'Doğrulama kodu',
Upload:'Yükleme',
Download:'İndir',
You_need_to_purchase_to_continue_use:'Kullanmaya devam etmek için satın almanız gerekir',
CheckBuy:'Satınalma Kontrolü',
Exists:'var',
NetworkUnavailable:'ağ kullanılamıyor',
Today:'Bugün',
Yesterday:'Dün',
ThisMonth:'Bu ay',
LastMonth:'Geçen ay',
nickname:'Takma ad',
storeName:'dükkan adı',
BuyStandAlone:'tek başına sürüm satın al',
PermissionDenied:'İzin reddedildi',
Boss:'Patron',

    login:'Oturum aç',
    operate:'işletmek',
    register:'Kayıt olmak',
    username:'Kullanıcı adı',
    password:'Parola',
    User:'kullanıcı',
    ok:'tamam',
    back:'Geri',
    success:'başarı',
    fail:'Başarısız',
    cancel:'iptal etmek',
    add:'Eklemek',
    edit:'Düzenle',
    delete:'silmek',
    refresh:'Yenile',
    close:'Kapat',
    cancel:'İptal etmek',
    return:'Dönüş',
    ElinkInvoice:'Elink Fatura',
    Purchase:'Satın alma',
    BaseData:'Baz Verileri',
    Sell:'Satmak',
    PurchaseReturns:'Satın alma iadeleri',
    SellReturns:'Satış iadesi',
    Inventory:'Envanter',
    Statistics:'istatistik',
    Receivable:'alacak',
    Payable:'ödenecek',
    Orders:'Emirler',
    StockTransfer:'Stok Transferi',
    StockRecall:'Stok hatırlama',
    Customer:'Müşteri',
    Supplier:'satıcı',
    Warehouse:'Depo',
    Color:'Renk',
    Size:'Boyut',
    Category:'Kategori',
    Category2:'Kategori2',
    Product:'Ürün',
    Account:'hesap',
    AccountType:'Hesap kategorisi',
    Staff:'Personel',
    typeone:'Kategori',
    typetwo:'Alt Kategori',
    ProductName:'Ürün adı',
    Specification:'Şartname',
    Barcode:'Barkod',
    Buyprice:'Fiyat almak',
    Sellprice:'Satış fiyatı',
    Wholesaleprice:'Toptan fiyat',
    Currentstock:'Mevcut stok',
    Unit:'birim',
    Initstock:'İnit stok',
    Parameter:'Parametre',
    Remark:'düşünce',
    Supplier:'satıcı',
    Customer:'Müşteri',
    Staff:'Personel',
    Receivable:'alacak',
    payable:'ödenecek',
    Receipts:'Makbuzlar',
    Paid:'Ücretli',
    Preferential:'Tercihli',
    DateDay:'tarih',
    OrderNum:'Sipariş numarası',
    Name:'isim',
    UserName:'Kullanıcı adı',
    IdNum:'Kimlik Numarası',
    BirthDay:'Doğum günü',
    SEX:'Seks',
    Female:'Kadın',
    Male:'Erkek',
    Select:'seçmek',
    Address:'Adres',
    Phone:'Telefon',
    Email:'E-posta',
    CardNum:'Kart numarası',
    Price:'Fiyat',
    QTY:'Adet',
    SupplierCategory:'Tedarikçi Kategorisi',
    CustomerCategory:'Müşteri Kategorisi',
    Power:'Güç',
    Role:'rol',
    save:'Kayıt etmek',
    image:'görüntü',
    search:'Arama',
    Year:'Yıl',
    Month:'Ay',
    Day:'Gün',
    Total:'Genel Toplam',
    WorkReport:'Çalışma raporu',
    Leave:'Ayrılmak',
    CheckIn:'Giriş',
    Announcement:'duyuru',
    Approval:'onay',
    Tracking:'Takip',
    Bill:'fatura',
    OrdersDetail:'Sipariş detay',
    Expense:'gider',
    Income:'Gelir',
    Userfor:'Kullanıcı',
    Amount:'Miktar',
    Title:'Başlık',
    News:'Haber',
    SelectFile:'Dosya Seç',
    Content:'içerik',
    Cost:'Maliyet',
    ApprovalUser:'Onay Kullanıcısı',
    ApprovalStatus:'Onay durumu',
    ApprovalRemark:'Onay notu',
    ApprovalDate:'Onay tarihi',
    SubmitDate:'Gönderme Tarihi',
    Status:'durum',
    FromDateTime:'Tarihten itibaren',
    ToDateTime:'Bugüne kadar',
    Subject:'konu',
    Latitude:'Enlem',
    Longitude:'Boylam',
    Print:'baskı',
    DataTrans:'Veri aktarımı',
    OA:'OA',
    Setting:'Set',
    Help:'yardım et',
    ScanOpenInPhone:'Telefonda Aç Tara',
    Building:'bina',
    Room:'Oda',
    HotelCheckIn:'Giriş',
    CheckOut:'Çıkış yapmak',
    Hotel:'Otel',
    Checkintime:'Zamanında kontrol et',
    Checkouttime:'Kontrol zamanı',
    Deposit:'Depozito',
    Cost:'Maliyet',
    RoomNum:'Oda Sayısı',
    Rent:'Kira',
    costday:'costday',
    rent:'kira',
    waternum:'Su derecesi',
    electricnum:'Elektrik derecesi',
    gasnum:'Gaz derecesi',
    watercost:'su maliyeti',
    electriccost:'elektrik maliyeti',
    gascost:'gaz maliyeti',
    cleaningcost:'temizlik maliyeti',
    networkcost:'şebeke maliyeti',
    tvcost:'televizyon maliyeti',
    managecost:'maliyeti yönetmek',
    othercost:'Diğer maliyet',
    totalcost:'toplam tutar',
    remark:'düşünce',
    addtime:'Zaman ekle',
    OpenInBrowser:'Tarayıcıda aç',
    InventoryProfit:'Stok karı',
    InventoryLoss:'Stok kaybı',
    Buy:'satın almak',



Refresh:'Yenile',
Add:'Ekle',
Search:'Ara',
Records:'kayıt',
}



// WEBPACK FOOTER //
// ./src/lang/tr.js